(function () {
  'use strict';

  /* @ngdoc object
   * @name flightDelayReport
   * @description
   *
   */
  angular
    .module('flightDelayReport', [
      'ui.router'
    ]);
}());
